var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpinionScaleQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7266 0.477051C12.8297 0.477051 13.7266 1.37393 13.7266 2.47705V4.72705H15.9766C16.3922 4.72705 16.7266 5.06143 16.7266 5.47705C16.7266 5.89268 16.3922 6.22705 15.9766 6.22705H13.7266V8.47705C13.7266 9.58018 12.8297 10.4771 11.7266 10.4771H10.7266C9.62344 10.4771 8.72656 9.58018 8.72656 8.47705V2.47705C8.72656 1.37393 9.62344 0.477051 10.7266 0.477051H11.7266ZM11.7266 1.97705H10.7266C10.4516 1.97705 10.2266 2.20205 10.2266 2.47705V8.47705C10.2266 8.75205 10.4516 8.97705 10.7266 8.97705H11.7266C12.0016 8.97705 12.2266 8.75205 12.2266 8.47705V2.47705C12.2266 2.20205 12.0016 1.97705 11.7266 1.97705ZM1.47656 4.72705H7.72656V6.22705H1.47656C1.0625 6.22705 0.726562 5.89268 0.726562 5.47705C0.726562 5.06143 1.0625 4.72705 1.47656 4.72705Z",
    fill: "#0E7490"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpinionScaleQuestion);
export default __webpack_public_path__ + "static/media/opinion-scale-question.4c40451770c8358a4aaa527b592b6e71.svg";
export { ForwardRef as ReactComponent };